import React from 'react';
import { useTranslation } from 'react-i18next';
import { Instances } from '../../../../../../constants';
import DownloadButton from '../../../../molecules/Download';
import HeaderTemplate from '../../../../templates/Header';

type HeaderPropsType = {
	filters: Record<string, any>;
	message: string;
};

const Header: React.FC<HeaderPropsType> = ({ filters, message }) => {
	const { t } = useTranslation();

	return (
		<HeaderTemplate title={t('assetsWidget')}>
			<DownloadButton
				instanceId={Instances.assetsDetailed}
				message={message}
				params={filters}
			/>
		</HeaderTemplate>
	);
};

export default Header;
